import type { RefObject } from 'react';
import { useEffect, useRef, useState } from 'react';

export interface InitialHeight {
  readonly elementRef: RefObject<HTMLDivElement>;
  readonly height: number;
}

/** Hook to measure the initial height of a component during loading phase and get its final height after loading */
export const useInitialHeight = (loadingCompleted: boolean = true): InitialHeight => {
  const elementRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number>(0);

  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (loadingCompleted) {
          observer.disconnect();
        } else {
          setHeight(entry.contentRect.height);
        }
      }
    });

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [loadingCompleted]);

  return { elementRef, height };
};
